var MAX_VALUE_DEFAULT = 100;
var MIN_VALUE_DEFAULT = 0;

export { MAX_VALUE_DEFAULT, MIN_VALUE_DEFAULT };
